import { motion } from "framer-motion";
import { Download, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
const WinterGuideSection = () => {
  return <section className="py-12 md:py-16 px-4 bg-white">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6">
            <div className="inline-flex items-center text-black px-4 py-2 rounded-full text-sm font-normal bg-[#c6e278]">
              <span>Nouveau Guide Événementiel</span>
            </div>
            
            <h2 className="text-4xl text-foreground font-normal md:text-4xl">Guide 2026</h2>
            
            <p className="text-lg text-muted-foreground">Découvrez les tendances et les lieux exclusifs pour vos événements d'entreprise cette année</p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-6 h-6 flex-shrink-0 mt-1 text-[#c6e278]" />
                <div>
                  <h3 className="font-semibold text-foreground">Destinations et territoires d'inspiration</h3>
                  <p className="text-muted-foreground">Des lieux d'exception en France et à l'étranger, pour vos événements inoubliables</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-6 h-6 flex-shrink-0 mt-1 text-[#c6e278]" />
                <div>
                  <h3 className="font-semibold text-foreground">Les Nouvelles Dynamiques Collectives</h3>
                  <p className="text-muted-foreground">Les nouveaux formats d'événements pour plus d'efficacité et d'inspiration</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-6 h-6 flex-shrink-0 mt-1 text-[#c6e278]" />
                <div>
                  <h3 className="font-semibold text-foreground">Les services Naboo</h3>
                  <p className="text-muted-foreground">Un accompagnement global pour imaginer et orchestrer vos événements de 2026</p>
                </div>
              </div>
            </div>
            
            <Button asChild size="lg" className="bg-[#C6E278] hover:bg-[#C6E278]/90 text-gray-900 gap-2 rounded-md hover:scale-105 hover:shadow-xl hover:shadow-cta-green/30 transition-all duration-300">
              <a href="https://download-autumn-guide.lovable.app/?lang=fr" target="_blank" rel="noopener noreferrer">
                <Download className="w-5 h-5" />
                Télécharger le guide gratuit
              </a>
            </Button>
          </motion.div>
          
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative">
            <div className="relative mx-auto">
              <img src="/lovable-uploads/guide-2026.gif" alt="Guide 2026" className="rounded-2xl shadow-2xl w-full" />
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-yellow-200 rounded-full blur-3xl opacity-50"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default WinterGuideSection;